import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';

/**
 * The old Go-Live Readiness overview (T-0224, T-0242): lands on the Go-live
 * criteria tab at its first criterion; the Overview tab carries the gauge
 * and the verdict the old overview led with.
 */
export const Route = createFileRoute('/engagements/$engagementId/golive/')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'criteria' });
  },
});
